module.exports = __webpack_public_path__ + "static/img/userAvatar.c6ffabc.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/userAvatar.png
// module id = HAWm
// module chunks = 1 2 3